import { joinCn } from '../util';

const twPickListGroup = {
  pickListGroup: 'h-full w-full gap-4',
  groupItemContainer: 'gap-[7px] flex-1',
  groupItemDivider: 'h-full w-0.5 bg-gray-200',
};

const twItem = {
  itemList: 'px-2 pt-2 overflow-x-hidden overflow-y-auto w-[308px] bg-white',

  itemListTitle: 'w-full text-headline-s',

  itemsContainer: 'flex flex-col overflow-auto',
  baseItem: joinCn(
    'flex items-center gap-2 bg-white p-1',

    'enabled:hover:shadow-sm',

    'enabled:active:bg-tertiary-200',
    'enabled:hover:shadow-sm',
    'aria-pressed:bg-tertiary-200',

    'disabled:bg-gray-200',
  ),
  checkIcon: joinCn('h-5 w-5'),
  get allGroupItem() {
    return joinCn(this.baseItem, 'text-body-s text-gray-400');
  },
  get itemContainer() {
    return joinCn(this.baseItem);
  },
};

const twPickedItemList = {
  pickedItemListContainer: 'bg-white w-[308px] overflow-y-auto',
  pickedItemList:
    'p-2 flex-1 rounded-md border border-gray-300 overflow-y-auto',
  pickedItemListTitle: 'text-headline-s text-secondary-300 w-full',
  pickedItemContentsWrapper: 'min-h-[497px] h-full overflow-y-auto',
  pickedItemContents: 'flex-wrap w-full gap-1',
};

const style = {
  ...twPickListGroup,
  ...twItem,
  ...twPickedItemList,
};

export default style;
